export const ApiConfig = {
  BaseUrl: '',
} as const;

export function isTmsApiUrl(url: string): boolean {
  const apiBaseUrl = `${ApiConfig.BaseUrl}/api`;
  return url === apiBaseUrl || url.startsWith(`${apiBaseUrl}/`);
}

export function resolveApiAssetUrl(url: string | null | undefined): string | null {
  if (!url) {
    return null;
  }

  if (/^https?:\/\//i.test(url) || url.startsWith('blob:')) {
    return url;
  }

  return `${ApiConfig.BaseUrl}${url.startsWith('/') ? url : `/${url}`}`;
}
